import * as S from './MetricItem.styled';
import { memo } from 'react';

export const MetricItem = memo(({ color, title, sum }) => {
  return (
    <S.Item>
      <S.ItemDetails>
        <S.Circle color={color}></S.Circle>
        <S.Title>{title}</S.Title>
      </S.ItemDetails>
      <S.Sum>{sum}</S.Sum>
    </S.Item>
  );
});

MetricItem.displayName = 'MetricItem';
